import { render, staticRenderFns } from "./FormMedecincreate.vue?vue&type=template&id=0972b104&"
import script from "./FormMedecincreate.vue?vue&type=script&lang=js&"
export * from "./FormMedecincreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports